import { TimeSlot as TSPickerTimeSlot } from '@ikea-customer-self-serve/ts-picker/dist/types/lib';
import { OutputFormData } from '@ikea-customer-self-serve/contact-form';
import { PriceProps } from '@ingka/price';
import { ServiceLocation } from '../../helpers';

export interface Payload {
  appointmentId?: string;
  plannerId?: string;
  projectId?: string;
  customer: OutputFormData;
  eventLocation: string;
}

export interface AppointmentResponse {
  orderNo: string;
  payOrderLink?: string;
  questionsToken?: string;
  payOrderLinkEnabled: boolean;
}

export interface PayOrderLinkResponse {
  link: string;
}

export type LocationType =
  | 'STORE'
  | 'HOME'
  | 'STORE_REMOTE'
  | 'REMOTE'
  | 'STORE_HOME';

export interface PriceParts extends Partial<PriceProps> {
  integerValue: string;
}

export interface FormattedPrice {
  mainPrice: PriceParts;
  secondaryPrice?: PriceParts;
}

export interface Savings {
  amount: number;
  validFromDateUTC: string;
  validToDateUTC: string;
  id: string;
}

export type PriceType = 'Business' | 'Family' | 'Private';

export interface PriceWithSavings {
  price: {
    currencyCode: string;
    priceExclTax?: number;
    priceExclTaxWithSavings?: number;
    priceInclTax?: number;
    priceInclTaxWithSavings?: number;
    priceType: PriceType;
    totalDiscount?: number;
  };
  savings?: Savings[];
}
export interface ReplacementServiceResponse {
  prices: PriceWithSavings[];
  locationType: LocationType;
  serviceProductId: string;
  serviceCode: string;
  operation: string;
}
export interface ReplacementService {
  location: ServiceLocation;
  serviceId: string;
  serviceCode: string;
  operation: string;
  displayPrice: DisplayPrice;
  customerPrice: CustomerPrice;
}

export type AvailableServicesInZipResponse = {
  prices: PriceWithSavings[];
  locationType: LocationType;
  serviceProductId: string;
  serviceCode: string;
  replacementService?: ReplacementServiceResponse;
};

export interface AvailableTimeslotsResponse {
  id: string;
  from: string;
  to: string;
  externalId: string;
}

export interface TimeSlots extends TSPickerTimeSlot {
  id: string;
  appointmentId: string;
  dateFrom: string;
  dateTo: string;
}

export interface Slots {
  date: string;
  timeSlots: TimeSlots[];
}

export interface TimeslotsResponse {
  timeSlots: Slots[];
}

export type PriceOfferType = 'family' | 'ibn' | 'tro';

export interface CustomerPrice {
  price: number;
  priceFormatted: FormattedPrice;
  priceOfferType?: PriceOfferType;
  totalSavings?: number;
}

export interface DisplayPrice {
  currencyCode: string;
  exclSavings: number;
  exclSavingsFormatted: FormattedPrice;
  inclSavings: number;
  inclSavingsFormatted: FormattedPrice;
  priceOfferType?: PriceOfferType;
  totalSavings: number;
  validFromDateUTC?: string;
  validToDateUTC?: string;
}

export interface AvailableService {
  serviceId: string;
  serviceCode: string;
  location: ServiceLocation;
  displayPrice: DisplayPrice;
  customerPrice: CustomerPrice;
  replacementService?: ReplacementService;
}

export interface ServicesResponse {
  services: AvailableService[];
}

export interface AvailableStore {
  value: string;
  text: string;
  street: string;
  zipCode: string;
  city: string;
}

export interface StoresResponse {
  stores: AvailableStore[];
}

export interface AvailableStoresResponse {
  name: string;
  street: string;
  zipCode: string;
  city: string;
  externalId: string;
}

export interface AvailableTimeSlot {
  id: string;
  from: string;
  to: string;
  timeSlotId: string;
}

export const NO_STORE_ID = 'default';
export const CONSOLIDATED_STORE_ID = 'all';
